import { ComponentProps } from 'react'
import {
  ComboBox,
  Cell,
  Row,
  makeDataField,
  DataBuilderForm,
} from '@integration-app/react'
import { DataSchema } from '@integration-app/sdk'

import { Popup } from 'components/Popup'
import { VStack } from 'styled-system/jsx'

import { Field } from './Field'
import classes from './PropertiesModal.module.css'
import { useSchemaBuilderContext } from '../../SchemaBuilder/SchemaContext'

export interface FieldPropertiesModalProps
  extends ComponentProps<typeof Popup.Root> {
  name?: string
  schema?: any

  propertiesSchema: DataSchema
  propertiesValue: any
  onPropertiesChange: (value: any) => void
  isRequired: boolean
  onRequiredChange: (value: boolean) => void
}

export function FieldPropertiesModal({
  name,
  schema,

  propertiesSchema,
  propertiesValue,
  onPropertiesChange,
  isRequired,
  onRequiredChange,
  ...props
}: FieldPropertiesModalProps) {
  const { variablesSchema } = useSchemaBuilderContext()

  const fieldName = name || ''

  return (
    <Popup.Root {...props}>
      <Popup.Window width={'4xl'} height={'2xl'}>
        <Popup.Content className={classes.popup_content}>
          <Field
            className={classes.fieldName}
            name={fieldName}
            schema={schema}
          />
          <VStack gap='2' alignItems='stretch'>
            {onRequiredChange && (
              <Row>
                <Cell.Name>Required</Cell.Name>
                <Cell.Combobox grow>
                  <ComboBox
                    value={isRequired}
                    schema={{ type: 'boolean' }}
                    variablesSchema={variablesSchema}
                    onChange={onRequiredChange}
                  />
                </Cell.Combobox>
              </Row>
            )}
            <DataBuilderForm
              field={makeDataField({
                schema: propertiesSchema,
                value: propertiesValue,
                variablesSchema,
              })}
              onChange={onPropertiesChange}
            />
          </VStack>
        </Popup.Content>
      </Popup.Window>
    </Popup.Root>
  )
}
